import React, { useCallback, useEffect, useRef, useState } from "react";
import CertificateVerificationNavbar from "./CertificateVerificationNavbar";
import CertificateVerificationFooter from "./CertificateVerificationFooter";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  validateCertificate,
  validateNewCertificate,
} from "../../redux/actions/certificate";
import { useDispatch, useSelector } from "react-redux";
import CertificateVerificationDesktopBody from "./CertificateVerificationDesktopBody";
import CertificateVerificationMobileBody from "./CertificateVerificationMobileBody";
import { toast } from "react-toastify";
import ReactPixel from "react-facebook-pixel";
import { Mixpanel } from "../../config/Mixpanel";
import Constants from "../../common/constants";
import {
  getCertifiedDetails,
  getCertifiedToken,
  getUserEngagement,
  linkedInPostTemplate,
  loginWithLinkedin,
  shareLinkedInPost,
  trackUser,
} from "../../redux/actions/certificateVerification";
import UserForm from "./UserForm";
import NavbarRouter from "./Navbar/NavbarRouter";
import {
  SET_CERTIFICATE_DATA,
  SET_CERTIFIED_DATA,
  SET_LOCK_STATUS,
  SET_RESET_DATA,
  SET_USER_CV_DATA,
  SET_USER_ENGAGEMENT_DATA,
  SET_USER_FORM_DATA,
  SET_USER_LINKEDIN_URL,
  SET_USER_TYPE,
} from "../../redux/actions/types";
import FooterRouter from "./Footer/FooterRouter";
import { use } from "react";
import { cleanSkillName } from "../../utils/generateCertificate";
import TopSocialProof from "./TopSocialProof";
import { AnimatePresence , motion} from "framer-motion";
import { v4 as uuidv4 } from 'uuid';

const CertificateVerification = ({ defaultLink }) => {
  const { uuid } = useParams();

  const dispatch = useDispatch();

  // Use dynamic redirectUri
  const redirectUri = `https://learntube.ai/verify/certificate`;
  const [certificateData, setCertificateData] = useState({});
  const navigate = useNavigate();
  const utmData = useSelector((store) => store?.userActivity?.utm_data);
  const email = useSelector((store) => store?.profileDetails?.email);
  const variant = useSelector((store)=> store?.certificateVerification?.userType);
  const [isLoading , setIsLoading] = useState(false);
  const [isManual, setIsManual] = useState(false);
  const uploadRef = useRef(null);
  const requestCvRef = useRef(null);
  const requestInterviewRef = useRef(null);
  const userDetails = useSelector(
    (store) => store?.certificateVerification?.userInfo
  );
  const location = useLocation();
  const lockedState = useSelector(
    (store) => store?.certificateVerification?.is_locked
  );
  const editStatus = useSelector(
    (store) => store?.certificateVerification?.is_edit
  );

  const certifiedData = useSelector(
    (store) => store?.certificateVerification?.certifiedData
  );
  const userType = useSelector(
    (store) => store?.certificateVerification?.userType
  );
  console.log('islocked' ,lockedState)
  const certificateFromRedux = useSelector((store)=>store?.certificateVerification?.certificateData);
  const [loading , setLoading] = useState(true);
  useEffect(() => {
    ReactPixel.pageView();
  
    if (uuid !== "success") {
      if (
        uuid?.split("-")?.[1]?.length === 1 &&
        uuid?.split("-")?.[1]?.toUpperCase() === "B"
      ) {
        console.log("run", uuid?.split("-")?.[1]);
        if(uuid !== certificateFromRedux?.unique_certificate_id){
          dispatch({type : SET_LOCK_STATUS , payload: true})
          setIsLoading(true);
          
           dispatch({type : SET_RESET_DATA , payload:  {
             userInfo : {
              name :"",
              email : "",
              role : "",
              role_data : "",
              role_headings :"",
              phone_number : ""
             },
             user_linked_url : "",
             user_type: "",
             is_locked: true,
             is_edit: false,
             certificateData : {},
             engagements : {},
             cvData:{},
             is_interview_requested : false,
             is_cv_requested : false
          }})
          setIsManual(false);
        }
        dispatch(
          validateNewCertificate(uuid?.toUpperCase(), (link) => {
             if(link.data.unique_certificate_id !== certificateFromRedux?.unique_certificate_id){
          dispatch({type : SET_LOCK_STATUS , payload: true})

           dispatch({type : SET_RESET_DATA , payload:  {
             userInfo : {
              name :"",
              email : "",
              role : "",
              role_data : "",
              role_headings :"",
              phone_number : ""
             },
             user_linked_url : "",
             user_type: "",
             is_locked: true,
             is_edit: false,
             certificateData : {},
             engagements : {},
             cvData:{},
             is_interview_requested : false,
             is_cv_requested : false
          }})
          
           setIsManual(false);
        }
            if (link.result === "failed") {
              toast.error(link.message + "Redirecting ");
              setTimeout(() => {
                navigate("/verify/certificate");
              }, 1000);
            } else {
             
          
           
              setCertificateData(link.data);
              setLoading(false);
            }
          }),
          (err) => {}
        );
      } else if (uuid?.split("-")?.[1]?.length === 1) {
        dispatch(
          validateCertificate(
            "",
            "unique_certificate_id",
            uuid,
            (link) => {
               if(link.data.unique_certificate_id !== certificateFromRedux?.unique_certificate_id){
          dispatch({type : SET_LOCK_STATUS , payload: true})

           dispatch({type : SET_RESET_DATA , payload:  {
             userInfo : {
              name :"",
              email : "",
              role : "",
              role_data : "",
              role_headings :"",
              phone_number : ""
             },
             user_linked_url : "",
             user_type: "",
             is_locked: true,
             is_edit: false,
             certificateData : {},
             engagements : {},
             cvData:{},
             is_interview_requested : false,
             is_cv_requested : false
          }})
          
           setIsManual(false);
        }
              if (link.result === "failed") {
                toast.error(link.message + "Redirecting ");
                setTimeout(() => {
                  navigate("/verify/certificate");
                }, 1000);
              } else {
                setCertificateData(link.data);
                setLoading(false);
              }
            },
            (err) => {}
          )
        );
      } else {
        console.log("run not", uuid?.split("-")?.[1]);

        dispatch(
          validateCertificate(
            uuid,
            "uuid",
            "",
            (link) => {
              if(link.data.unique_certificate_id !== certificateFromRedux?.unique_certificate_id){
          dispatch({type : SET_LOCK_STATUS , payload: true})
           dispatch({type : SET_RESET_DATA , payload:  {
             userInfo : {
              name :"",
              email : "",
              role : "",
              role_data : "",
              role_headings :"",
              phone_number : ""
             },
             user_linked_url : "",
             user_type: "",
             is_locked: true,
             is_edit: false,
             certificateData : {},
             engagements : {},
             cvData:{},
             is_interview_requested : false,
             is_cv_requested : false
          }})
 setIsManual(false);
        }
              if (link.result === "failed") {
                toast.error(link.message + "Redirecting ");
                setTimeout(() => {
                  navigate("/verify/certificate");
                }, 1000);
              } else {
                setCertificateData(link.data);
                setLoading(false);
              }
            },
            (err) => {}
          )
        );
      }
    } else {
      setCertificateData(JSON.parse(localStorage.getItem("userData")));
      setLoading(false);
    }
  }, [dispatch, navigate, uuid]);


  useEffect(()=>{

    return ()=>{
      dispatch({type : SET_USER_TYPE , payload: ""});
    }
  } ,[]);

  console.log("userType", userType);

  useEffect(() => {
    Mixpanel.people.set({
      utm_source: utmData?.utmSource,
      utm_medium: utmData?.utmMedium,
      utm_campaign: utmData?.utmCampaign,
      utm_content: utmData?.utmContent,
      utm_term: utmData?.utmTerm,
    });
  }, [userDetails?.email, utmData?.utmCampaign, utmData?.utmContent, utmData?.utmMedium, utmData?.utmSource, utmData?.utmTerm]);

  useEffect(() => {
    if (certificateData) {
      dispatch({ type: SET_CERTIFICATE_DATA, payload: certificateData });
    }
  }, [certificateData, dispatch]);

  const targetRef = useRef(null); // the div to observe
  const [isVisible, setIsVisible] = useState(false); // visibility state

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      {
        threshold: 0.1, // consider visible if at least 10% in view
      }
    );

    if (targetRef.current) {
      observer.observe(targetRef.current);
    }

    return () => {
      if (targetRef.current) {
        observer.unobserve(targetRef.current);
      }
    };
  }, [variant]);

  useEffect(() => {

    if(!userType && certificateData?.email && userDetails?.email && userDetails?.role && userDetails?.name){
    function levenshtein(a, b) {
      if (!a || !b) return Math.max((a || '').length, (b || '').length);
      a = a.toLowerCase().trim();
      b = b.toLowerCase().trim();
      const matrix = [];
      for (let i = 0; i <= b.length; i++) {
          matrix[i] = [i];
      }
      for (let j = 0; j <= a.length; j++) {
          matrix[0][j] = j;
      }
      for (let i = 1; i <= b.length; i++) {
          for (let j = 1; j <= a.length; j++) {
              if (b.charAt(i - 1) === a.charAt(j - 1)) {
                  matrix[i][j] = matrix[i - 1][j - 1];
              } else {
                  matrix[i][j] = Math.min(
                      matrix[i - 1][j - 1] + 1, // substitution
                      matrix[i][j - 1] + 1,     // insertion
                      matrix[i - 1][j] + 1      // deletion
                  );
              }
          }
      }
      return matrix[b.length][a.length];
  }
    if(certificateData?.email === userDetails?.email){
      dispatch({type : SET_USER_TYPE , payload: "owner"});
    }
    else{
      const distance = levenshtein(certificateData?.name, userDetails?.name);
      console.log("distance", distance , certificateData?.name, userDetails?.name);
      if(distance <= 2){
        dispatch({type : SET_USER_TYPE , payload: "owner"});
      }
      else{
        const distance2 = levenshtein(certificateData?.name?.split(" ")[0], userDetails?.name?.split(" ")[0]);
        console.log("distance2", distance2 , certificateData?.name?.split(" ")[0], userDetails?.name?.split(" ")[0]);
        if(distance2 <= 1){
          dispatch({type : SET_USER_TYPE , payload: "owner"});
        }
        else if(userDetails?.role === "Recruiter / Team Leads" || userDetails?.role === "Founder / Business Owner"){
          dispatch({type : SET_USER_TYPE , payload: "recruiter"});
        }
        else{
        dispatch({type : SET_USER_TYPE , payload: "normal"});
        }
      }
    }
  }
    
  }, [certificateData?.email, certificateData?.name, dispatch, userDetails?.email, userDetails?.name, userDetails?.role, userType]);

  useEffect(() => {
    console.log("logging", certificateData);
    if (certificateData?.certificate_type === "certified") {
      console.log("logging");
      const skill_id = certificateData?.unique_certificate_id?.split("-")?.[3];
      dispatch(
        getCertifiedDetails(
          skill_id,
          (successObj) => {
            dispatch(
              getCertifiedToken(skill_id, (res) => {
                dispatch({
                  type: SET_CERTIFIED_DATA,
                  payload: { ...successObj?.data, token: res?.data },
                });
              })
            );
          },
          (errorObj) => {}
        )
      );
    }
    else{
       dispatch({
                  type: SET_CERTIFIED_DATA,
                  payload: { },
                });
    }
  }, [certificateData, dispatch]);

  function handlerCertified({
    utm_source,
    utm_medium,
    skill_name,
    is_landing,
    is_not_skill,
  }) {
    let skillName = skill_name ? skill_name : certificateData?.certificate_name;
    if (
      certificateData?.certificate_type === "certified" &&
      certifiedData?.is_paid === true &&
      !is_landing && !is_not_skill
    ) {
      window.open(
        `https://certified.learntube.ai/analysis/leaderboard/un-paid?token=${certifiedData?.token}&unique_certificate_id=${certificateData?.unique_certificate_id}&utm_medium=${utm_medium}&utm_source=${utm_source}`,
        "_blank"
      );
    }else if(is_not_skill){

      window.open(
        `https://certified.learntube.ai/?utm_source=${utm_source}&utm_medium=${utm_medium}&unique_certificate_id=${certificateData?.unique_certificate_id}`,
        "_blank"
      );
    } else {

      if(skillName){
      window.open(
        `https://certified.learntube.ai/skill_name=${skillName}?utm_source=${utm_source}&utm_medium=${utm_medium}&unique_certificate_id=${certificateData?.unique_certificate_id}`,
        "_blank"
      );
      }else{
        window.open(
          `https://certified.learntube.ai/?utm_source=${utm_source}&utm_medium=${utm_medium}`,
          "_blank"
        );
      }
    }
  }

  function handlerPersonalise({ utm_source, utm_medium }) {
    window.open(
      `https://personalise.learntube.ai?utm_source=${utm_source}&utm_medium=${utm_medium}`,
      "_blank"
    );
  }

  const buttonStyles = {
    style1:
      "w-[142px] h-[41px] text-[#7fc241] border-2 border-[#7fc241] text-[16px] mr-1 ml-1 rounded-lg font-semibold w-[50%]",
    style2:
      "w-[142px] h-[41px] text-black bg-[#7fc241] border-2 border-[#7fc241] text-[16px] ml-1 mr-1  rounded-lg font-semibold w-[50%]",
  };

  const condition = true;

  // return (
  //   <>
  //     {/* <CertificateVerificationNavbar certificateData={certificateData}/> */}
  //     {window.innerWidth > 768 ? <CertificateVerificationDesktopBody certificateData={certificateData}/> : <CertificateVerificationMobileBody certificateData={certificateData} />}

  //     <CertificateVerificationFooter/>
  //     <div className='sticky bottom-0 p-4 flex items-center justify-center bg-[#26588B]    md:hidden'>
  //       <button className={condition ? buttonStyles.style1 :  buttonStyles.style2 } onClick={(e)=> {Mixpanel.track(Constants.Mixpanel.GET_CERTIFIED_BUTTON_CLICKED); window.open('https://certified.learntube.ai?utm_source=certificate-verification&utm_medium=get-certified','_blank')}}>Get Certified</button>
  //       <button className={condition ? buttonStyles.style2 :  buttonStyles.style1 } onClick={(e)=> { Mixpanel.track(Constants.Mixpanel.BUILD_PERSONALISED_COURSE_BUTTON_CLICKED); window.open('https://personalise.learntube.ai?utm_source=certificate-verification&utm_medium=build-course' , '_blank')} }>Build A Course</button>
  //     </div>
  //   </>
  // )
  const processLinkedInCode = useCallback(
    async (code, type) => {
     
    
      if (code && type !== "share") {
        dispatch(
          loginWithLinkedin(
            code,
            redirectUri,
            (successObj) => {
              toast.success("Logged in with LinkedIn successfully.");
          
              
              dispatch({
                type: SET_USER_LINKEDIN_URL,
                payload: successObj?.data?.linkedin_profile_url,
              });
              const newFormData = {
                name: successObj?.data?.name,
                email: successObj?.data?.email,
                role: successObj?.data?.current_role,
                role_data: successObj?.data?.current_role_detail,
                role_headings: "",
                id: successObj?.data?.id,
                phone_number: successObj?.data?.phone_number,
              };
              dispatch({ type: SET_USER_FORM_DATA, payload: newFormData });
              dispatch({type: SET_USER_LINKEDIN_URL,payload: successObj?.data?.linkedin_profile_url});
              dispatch({
                type: SET_USER_CV_DATA,
                payload: successObj?.data?.user_cv,
              });
              dispatch({ type: SET_LOCK_STATUS, payload: false });
              Mixpanel.identify(successObj?.data?.email);
              Mixpanel.people.set({
                $name: successObj?.data?.name,
              })
              dispatch(
                trackUser(
                  successObj?.data?.email,
                  certificateData?.unique_certificate_id,
                  certificateData?.email,
                  (successObj) => {
                    dispatch(
                      getUserEngagement(
                        certificateData?.unique_certificate_id,
                        newFormData?.id , 
                        (successObj) => {
                         const engagementData = successObj?.data;

const comments = engagementData?.comments || [];

// Find last occurrence from original array
const matchIndexFromEnd = [...comments].reverse().findIndex(
  item => item?.certificate_verification_users_id === userDetails?.id
);

// Convert reversed index to original index
const matchIndex =
  matchIndexFromEnd !== -1 ? comments.length - 1 - matchIndexFromEnd : -1;

let reorderedComments = [];

if (matchIndex !== -1) {
  let matchedItem = comments[matchIndex];
  matchedItem = {
    ...matchedItem,
    user_name: matchedItem?.['user_name'] + ' (You)'
  };

  const remaining = [
    ...comments.slice(0, matchIndex),
    ...comments.slice(matchIndex + 1)
  ];

  reorderedComments = [matchedItem, ...remaining];
} else {
  reorderedComments = comments;
}

dispatch({
  type: SET_USER_ENGAGEMENT_DATA,
  payload: { ...engagementData, comments: reorderedComments }
});

                        },
                        (errorObj) => {}
                      )
                    );
                  },
                  (errorObj) => {}
                )
              );
            },
            (errorObj) => {
              toast.error("Login failed. Please try again or fill the form manually.")
            }
          )
        );
      } else if (code) {
        toast.success(
          "Great, successfully posted. Maximise sharing for best career benefits!"
        );
        dispatch(
          linkedInPostTemplate(
            certificateData?.certificate_name,
            "high",
            (successObj) => {
              console.log(code , 'code');
              const response  = successObj?.data;
              dispatch(
                shareLinkedInPost(
                  code,
                  redirectUri + '?type=share',
                  "",
                  "",
                  certificateData?.email,
                  "certificate-verification-page",
                  {
                    user_name: certificateData?.name,
                    certificate_id: certificateData?.unique_certificate_id,
                    verification_url:
                      redirectUri +
                       + certificateData?.unique_certificate_id,
                    skill_name: certificateData?.certificate_name,
                  },
                  `${
                    response?.line1
                  }\n\nThe certification came through LearnTube.ai's P.E.A.K.S. assessment in ${cleanSkillName(
                    certificateData?.certificate_name
                  )}, based on real job challenges and quick decision making.\n\n${
                    response?.line2
                  }\n\nProud to be officially certified and featured alongside top professionals from companies like ${
                    response?.relevant_companies
                  }.\n\n${
                    response?.founder_mention_line
                  }.\n\n📌 Scan the certificate to see how I did or try it yourself:👉 ${`https://certified.learntube.ai?utm_source=linkedin&utm_medium=post&unique_certificate_id=${certificateData?.unique_certificate_id}`}\n\n${
                    response?.hashtag1
                  } ${response?.hashtag2} #LearnTubeCertified #PEAKSAssessment`,
                  certificateData?.certificate_image_link
                )
              );
            },
            (errorObj) => {}
          )
        );
      }
    },
    [certificateData?.certificate_image_link, certificateData?.certificate_name, certificateData?.email, certificateData?.name, certificateData?.unique_certificate_id, dispatch, redirectUri, userDetails?.email, userDetails?.id]
  );

  // Listen for message from popup window and fallback to URL param
  useEffect(() => {
    let timeoutId;
    let handled = false;
    function handleLinkedInCode(code, type) {
      if (handled) return;
      handled = true;
      if (code) {
        processLinkedInCode(code, type);
        localStorage.removeItem("linkedin_auth_code");
        localStorage.removeItem("linkedin_auth_type");
      }
    }
    // 1. Listen for postMessage
    const handleMessage = (event) => {
      if (event.origin === window.location.origin) {
        if (event.data === "linkedin_auth_complete") {
          const code = localStorage.getItem("linkedin_auth_code");
          const type = localStorage.getItem("linkedin_auth_type");
          handleLinkedInCode(code, type);
        } else if (event.data === "linkedin_auth_error") {
          handled = true;
         // toast.error("LinkedIn authentication failed. Please try again.");
          localStorage.removeItem("linkedin_auth_code");
          localStorage.removeItem("linkedin_auth_type");
        }
      }
    };
    window.addEventListener("message", handleMessage);
    // 2. Fallback: check for code in URL (mobile)
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");
    const type = urlParams.get("type");
    if (code) {
      handleLinkedInCode(code, type);
      // Remove code from URL (optional, for cleanliness)
      const url = new URL(window.location);
      url.searchParams.delete("code");
      url.searchParams.delete("type");
      window.history.replaceState({}, document.title, url.pathname);
    }
    // 3. Timeout: if no message in 10s, show error
    timeoutId = setTimeout(() => {
      if (!handled) {
       // toast.error("LinkedIn authentication timed out. Please try again.");
        localStorage.removeItem("linkedin_auth_code");
        localStorage.removeItem("linkedin_auth_type");
      }
    }, 10000);
    return () => {
      window.removeEventListener("message", handleMessage);
      clearTimeout(timeoutId);
    };
  }, [processLinkedInCode]);

  // Function to open LinkedIn login in popup
  const openLinkedInLogin = (type) => {
    let linkedinAuthUrl = "";
    if (type === "share") {
      linkedinAuthUrl = `https://www.linkedin.com/oauth/v2/authorization?client_id=86h7ayn66hgjuf&redirect_uri=${encodeURIComponent(redirectUri + '?type=share')}&response_type=code&scope=w_member_social%20profile%20openid%20email%20r_basicprofile`;
    } else {
      linkedinAuthUrl = `https://www.linkedin.com/oauth/v2/authorization?client_id=86h7ayn66hgjuf&redirect_uri=${encodeURIComponent(redirectUri)}&response_type=code&scope=w_member_social%20profile%20openid%20email%20r_basicprofile`;
    }

    // Try to open popup
    let popup = null;
    try {
      popup = window.open(
        linkedinAuthUrl,
        "linkedin-login",
        "width=600,height=600,scrollbars=yes,resizable=yes"
      );
    } catch (e) {
      popup = null;
    }

    // If popup blocked or failed, fallback to redirect (mobile)
    if (!popup || popup.closed || typeof popup.closed === 'undefined') {
      window.location.href = linkedinAuthUrl;
      return;
    }

    // Optional: Monitor if popup is closed manually
    const checkClosed = setInterval(() => {
      if (popup.closed) {
        clearInterval(checkClosed);
        // Optionally, show error if not completed
      }
    }, 1000);
  };


  const [isProofVisible, setIsProofVisible] = useState(true);


  useEffect(() => {
    const timer = setTimeout(() => {
      setIsProofVisible(false);
    }, 7000);

    return () => clearTimeout(timer);
  }, []);

  const isLocked = useSelector((store) => store?.certificateVerification?.is_locked);
  const pageRef = useRef(null);

  useEffect(()=>{
   if(pageRef?.current) 
   pageRef?.current?.scrollIntoView()
  },[isLocked,variant]);


  return (
    <div
      classNam="w-full relative h-screen flex flex-col justify-center items-center"
      style={{
        backgroundImage: `radial-gradient(circle at center, #26496A 0%, #182C3F 100%)`,
      }}
      ref={pageRef}
    >

        <AnimatePresence>
      {variant !== "owner" && !isLocked && isProofVisible && (
        <motion.div 
          className="fixed flex justify-center w-full top-4 z-[9999] px-2"
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.3 }}
        >
          <div className="w-full md:max-w-2xl">
            <TopSocialProof/>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
      <div className="flex  w-full flex-col items-center justify-center p-4 pb-10">
        <div className="w-full  md:max-w-2xl">
          {(lockedState || editStatus) && (
            <UserForm
              certificateData={certificateData}
              isModalEnabled={lockedState || editStatus}
              openLinkedInLogin={openLinkedInLogin}
              uuid={uuid}
              isManual={isManual}
              setIsManual={setIsManual}
            />
          )}
          <NavbarRouter />
          <CertificateVerificationMobileBody
            openLinkedInLogin={openLinkedInLogin}
            uploadRef={uploadRef}
            handlerCertified={handlerCertified}
            handlerPersonalise={handlerPersonalise}
            requestCvRef={requestCvRef}
            requestInterviewRef={requestInterviewRef}
            targetRef={targetRef}
            loading={loading}
          />
        </div>
      </div>
      <div className="flex w-full flex-col items-center justify-center ">
        <div className="md: w-full max-w-2xl">
          <FooterRouter
            requestCvRef={requestCvRef}
            requestInterviewRef={requestInterviewRef}
            handlerCertified={handlerCertified}
            handlerPersonalise={handlerPersonalise}
          />
        </div>
      </div>
      {!isVisible && (
        <div className="sticky bottom-0 z-[999999]  flex items-center justify-center">
        <div className=" md:max-w-2xl w-full flex items-center justify-center bg-[#26588B] p-4">
           <button
            className={condition ? buttonStyles.style1 : buttonStyles.style2}
            onClick={(e) => {
              // Mixpanel.track(Constants.Mixpanel.GET_CERTIFIED_BUTTON_CLICKED);
              if(variant === "owner"){
                Mixpanel.track(Constants.Mixpanel.CERTIFICATE_VERIFICATION_OWNER_PAGE_STICKY_CTA_GET_CERTIFIED_CLICKED);
              }
              else if(variant === "recruiter"){
                Mixpanel.track(Constants.Mixpanel.CERTIFICATE_VERIFICATION_RECRUITER_PAGE_STICKY_CTA_GET_CERTIFIED_CLICKED);
              }
              else{
                Mixpanel.track(Constants.Mixpanel.CERTIFICATE_VERIFICATION_NORMAL_PAGE_STICKY_CTA_GET_CERTIFIED_CLICKED);
              }
              handlerCertified({utm_medium : 'get-certfied' , utm_source : 'certificate-verification' , is_landing:true})
            }}
          
          >
            Get Certified
          </button>
           <button
            className={condition ? buttonStyles.style2 : buttonStyles.style1}
            onClick={(e) => {
             if(variant === "owner"){
                Mixpanel.track(Constants.Mixpanel.CERTIFICATE_VERIFICATION_OWNER_PAGE_STICKY_CTA_BUILD_PERSONALIZED_COURSE_CLICKED);
              }
              else if(variant === "recruiter"){
                Mixpanel.track(Constants.Mixpanel.CERTIFICATE_VERIFICATION_RECRUITER_PAGE_STICKY_CTA_BUILD_PERSONALIZED_COURSE_CLICKED);
              }
              else{
                Mixpanel.track(Constants.Mixpanel.CERTIFICATE_VERIFICATION_NORMAL_PAGE_STICKY_CTA_BUILD_PERSONALIZED_COURSE_CLICKED);
              }
            handlerPersonalise({utm_medium : 'build-course' , utm_source : 'certificate-verification'})
            }}
          >
            Build A Course
          </button>
         
         
        </div>
        </div>
      )}
    </div>
  );
};

export default CertificateVerification;
